// PieChart.js
import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ labels, counts }) => {

  const data = {
    labels: labels, // Labels for the chart
    datasets: [
      {
        label: 'Incident Data',
        data: counts, // Data counts from the prop
        backgroundColor: [
          '#ea5455',
          '#00cfe8',
          '#FFFF00',
          '#28c76f',
          '#7367f0',
          '#FFA500',
        ],
        borderColor: [
          '#ea5455',
          '#00cfe8',
          '#FFFF00',
          '#28c76f',
          '#7367f0',
          '#FFA500',
        ],
        borderWidth: 1,
      },
    ],
  };

  return <Pie data={data} options={{ maintainAspectRatio: false, responsive: true }} />;
};

export default PieChart;
